import { RateSchema, RateSource } from "@redotech/fx";
import { zCurrency } from "@redotech/money/usd-amounts";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * Subscribe to many live FX rates over ONE stream: the current rate for each
 * requested (source, base, quote) on connect, then a new {@link Rate} whenever
 * the warmed cache changes. Each emitted Rate self-identifies via its
 * `source`/`base`/`quote`.
 */
export const watchFxRates = unaryStreamRpc({
  name: "watchFxRates",
  input: z.object({
    // Bounded so one client can't open an unbounded merged subscription / Redis
    // demand set. 50 comfortably covers any single view's watched pairs.
    refs: z
      .array(
        z.object({
          base: zCurrency,
          quote: zCurrency,
          source: createEnum(RateSource),
        }),
      )
      .max(50),
  }),
  output: RateSchema,
});
